const userManagerAppRoutes = {
  ROOT: "/manage",

  USERS_VIEW_RELATIVE: "users",
  USERS_VIEW_ABSOLUTE: "/manage/users",

  ROLES_VIEW_RELATIVE: "roles",
  ROLES_VIEW_ABSOLUTE: "/manage/roles",

  ADMIN_PANEL_RELATIVE: "admin",
  ADMIN_PANEL_ABSOLUTE: "/manage/admin",
};

export const routePaths = {
  LOGIN: "/login",
  RESET_PASSWORD: "/reset",
  SET_PASSWORD: "/setPassword",
  INVITATION: "/invitation/:invitationIdParam",
  PARTNERS: "/partners",
  SUPPORT_CODE: "/supportCode",
  RUN_AS: "/runAs",
  PRODUCTS_VIEW: "/",
  USER_MANAGER_APP: userManagerAppRoutes,
};
